import { createStackNavigator } from '@react-navigation/stack';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';
import AccountButton from 'src/presentation/components/molecules/AccountButton';
import { useHeaderStyle, useModalHeaderStyle } from 'src/presentation/hooks/useHeaderStyle';
import { useActiveLanguage } from 'src/presentation/hooks/useActiveLanguage';
import {
	headerCloseButtonOnImage,
	headerlessStackScreenOptions,
	transparentHeaderScreenOptions,
} from 'src/presentation/navigation/defaultScreenOptions';
import type { LoyaltyNavigation } from 'src/presentation/navigation/types/NavigationTypes';
import LoyaltyScreen from 'src/presentation/screens/LoyaltyScreen';
import ResortScreen from 'src/presentation/screens/ResortScreen';

const Stack = createStackNavigator<LoyaltyNavigation>();

export default function LoyaltyStackNavigator() {
	useActiveLanguage();

	const headerStyle = useHeaderStyle();
	const modalHeaderStyle = useModalHeaderStyle();

	return (
		<Stack.Navigator screenOptions={{ ...headerlessStackScreenOptions, title: Translations.tabsThermenfans }}>
			<Stack.Screen
				component={LoyaltyScreen}
				name={Constants.screenLoyalty}
				options={{
					headerShown: true,
					headerStyle,
					headerRight: () => <AccountButton style={{ marginHorizontal: Dimens.padding18 }} />,
				}}
			/>
			<Stack.Screen
				component={ResortScreen}
				name={Constants.screenLoyaltyResort}
				options={({ navigation: screenNavigation }) => ({
					...transparentHeaderScreenOptions,
					presentation: 'modal',
					headerStyle: modalHeaderStyle,
					headerLeft: () => null,
					headerRight: () => headerCloseButtonOnImage({ navigation: screenNavigation }),
				})}
			/>
		</Stack.Navigator>
	);
}
